// ========== FESTIVITÀ ITALIANE ==========

// 10 festività fisse
const FIXED_HOLIDAYS = [
  { month: 1, day: 1 },   // Capodanno
  { month: 1, day: 6 },   // Epifania
  { month: 4, day: 25 },  // Liberazione
  { month: 5, day: 1 },   // Festa del Lavoro
  { month: 6, day: 2 },   // Festa della Repubblica
  { month: 8, day: 15 },  // Ferragosto
  { month: 11, day: 1 },  // Ognissanti
  { month: 12, day: 8 },  // Immacolata
  { month: 12, day: 25 }, // Natale
  { month: 12, day: 26 }, // Santo Stefano
];

// Algoritmo Anonymous Gregorian per calcolare la Pasqua
function computeEaster(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return { month, day };
}

// Genera tutte le festività per un anno (incluso Lunedì dell'Angelo)
export function getHolidaysForYear(year) {
  const holidays = FIXED_HOLIDAYS.map(({ month, day }) => ({ month, day }));

  const easter = computeEaster(year);
  // Pasqua
  holidays.push({ month: easter.month, day: easter.day });

  // Lunedì dell'Angelo (giorno dopo Pasqua)
  const easterDate = new Date(year, easter.month - 1, easter.day);
  easterDate.setDate(easterDate.getDate() + 1);
  holidays.push({ month: easterDate.getMonth() + 1, day: easterDate.getDate() });

  return holidays;
}

// Verifica se un giorno è festivo
export function isHoliday(day, month, year) {
  const holidays = getHolidaysForYear(year);
  return holidays.some((h) => h.month === month && h.day === day);
}

// Verifica se un giorno è weekend (sabato o domenica)
export function isWeekend(day, month, year) {
  const date = new Date(year, month - 1, day);
  const dow = date.getDay();
  return dow === 0 || dow === 6;
}

// Verifica se un giorno non è lavorativo (weekend o festivo)
export function isNonWorkingDay(day, month, year) {
  return isWeekend(day, month, year) || isHoliday(day, month, year);
}

// Calcola i giorni lavorativi in un mese
export function getWorkingDaysInMonth(year, month) {
  const daysInMonth = new Date(year, month, 0).getDate();
  let count = 0;
  for (let d = 1; d <= daysInMonth; d++) {
    if (!isNonWorkingDay(d, month, year)) {
      count++;
    }
  }
  return count;
}
